"use strict";

exports.__esModule = true;

exports["default"] = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.18.0@babel-runtime/helpers/classCallCheck.js
 ** module id = 3
 ** module chunks = 0
 **/